export default __webpack_public_path__ + "static/media/event-price.a21d1aa8.svg";